import { atom } from "jotai";

export const originalDataAtomObject = atom({
  jobs: [],
  totalCount: 0,
  histograms: [],
});
originalDataAtomObject.debugLabel = 'originalDataAtomObject';

export const filtersAtomObject = atom({});
filtersAtomObject.debugLabel = 'filtersAtomObject';

export const originalFiltersAtomObject = atom({});
originalFiltersAtomObject.debugLabel = 'originalFiltersAtomObject';

export const filtersLoadingAtomBool = atom(false);
filtersLoadingAtomBool.debugLabel = 'filtersLoadingAtomBool';

export const searchPerformedAtomBool = atom(false);
searchPerformedAtomBool.debugLabel = 'searchPerformedAtomBool';

export const isLoadingSkeletonAtomBool = atom(false);
isLoadingSkeletonAtomBool.debugLabel = 'isLoadingSkeletonAtomBool';

export const isLoadingAtomBool = atom(false);
isLoadingAtomBool.debugLabel = 'isLoadingAtomBool';

export const errorMessageAtomString = atom(null);
errorMessageAtomString.debugLabel = 'errorMessageAtomString';

export const isGridViewAtomBool = atom(false);
isGridViewAtomBool.debugLabel = 'isGridViewAtomBool';

export const showMapAtomBool = atom(false);
showMapAtomBool.debugLabel = 'showMapAtomBool';

export const filtersCommuteAtomObject = atom({});
filtersCommuteAtomObject.debugLabel = 'filtersCommuteAtomObject';

export const searchBarFiltersAtomObject = atom({});
searchBarFiltersAtomObject.debugLabel = 'searchBarFiltersAtomObject';

export const expandedJobDetailsAtomObject = atom({});
expandedJobDetailsAtomObject.debugLabel = 'expandedJobDetailsAtomObject';